<template>
  <div>
    <div class="content-container">
      <el-row :gutter="10">
        <el-col :span="1.5">
          <el-cascader v-model="query.courseType" :options="courseTypeList" :props="courseTypeProps"
            placeholder="请选择课程分类" style="width: 240px;" :show-all-levels="false" @change="handleQuery" clearable />
        </el-col>
        <el-col :span="1.5">
          <el-input v-model="query.courseName" placeholder="搜索课程" clearable style="width: 240px" class="search"
            @change="handleQuery" />
        </el-col>
      </el-row>
      <div class="course-card-list">
        <transition name="fade-transform" mode="out-in" v-for="course in courseList" :key="course.id">
          <div class="single-popular-course mb-30" @click="getCourseware(course)">
            <ImagePreview :src="course.courseImage" alt="" width="100%" :height="260" />
            <div class="course_title">
              {{ course.courseName }}
            </div>
            <div class="course_info">
              <div class="course_info_left">
                <div>
                  课程分类：{{ course.courseTypeName }}
                </div>
                <div>
                  开课时间：{{ course.createTime }}
                </div>
                <!-- <div v-else>
                  课程售价：<span class="price">￥{{ course.coursePrice }}</span>
                </div> -->
              </div>
              <div class="course_info_right" :class="{ 'active': course.isCollect == 0 }">
                <i class="el-icon-star-on" aria-hidden="true" @click.stop="getIscollect(course)"></i>
              </div>
            </div>
          </div>
        </transition>
        <!-- 对齐 -->
        <i v-if="courseList !== undefined && courseList.length > 0" v-for="count in (courseList.length)"
          :key="count"></i>
      </div>
      <el-row style="text-align: center; margin-bottom: 50px;" v-if="courseList.length > 0">
        <el-col :span="24">
          <el-button type="default" @click="scrollList" :loading="loading"
            style="margin-bottom: 100px;">加载更多</el-button>
        </el-col>
      </el-row>
      <el-row style="text-align: center; margin-bottom: 50px;" v-else>
        <el-col :span="24">
          <div>
            暂无数据
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import { getClassifyData, getCourseList, getCollect,getCourseState } from '@/api/courseModel/index'
import { messageWarn, notifyFail } from '@/utils/util'
import modal from '@/plugins/modal'

export default {
  data() {
    return {
      total: 0,
      loading: true,
      isLastPage: false,
      query: {
        courseType: '',
        courseName: '',
        pageNum: 1,
        pageSize: 8,
      },
      courseTypeList: [],
      courseTypeProps: {
        value: 'dictCode',
        label: 'dictLabel',
        children: 'children',
        checkStrictly: false,
        // 关键：设置emitPath为false，只返回最后一级的值
        emitPath: false,
        // 关键：使用disabled判断是否可展开
        disabled: (data, node) => {
          return !data.children || data.children.length === 0;
        }
      },
      courseList: [],
      banner_bg: require("@/assets/img/bg-img/bg2.jpg")
    }
  },
  created() {
    this.getCourseList()
    this.getClassifyData();
  },
  methods: {
    // 过滤函数
    filterEmptyChildren(data) {
      console.log(data)
      return data.map(item => {
        if (item.children && item.children.length > 0) {
          return {
            ...item,
            children: this.filterEmptyChildren(item.children)
          };
        } else if (item.children && item.children.length === 0) {
          // 删除空的children属性
          const { children, ...rest } = item;
          return rest;
        }
        return item;
      })
    },
    // 课程分类查询
    getClassifyData() {
      getClassifyData({ "dictType": "sys_courseware_classification" }).then(response => {
        const option = this.filterEmptyChildren(response.data);
        console.log(option)
        this.courseTypeList = option
      })
    },
    // 加载课程列表
    getCourseList() {
      this.loading = true
      getCourseList(this.query).then(response => {
        console.log(1111111)
        const { total, rows } = response
        this.updateCourseList(rows)
        this.total = total
        this.isLastPage = total < (this.query.pageNum * this.query.pageSize)
        this.loading = false
      }).catch(() => {
        notifyFail(this, '加载数据失败！')
        this.loading = false
      })
    },
    // 筛选条件查询
    handleQuery() {
      console.log(11111)
      this.query.pageNum = 1;
      this.getCourseList()
    },
    // 收藏
    getIscollect(row) {
      var param = {
        resourseId: row.id,
        type: 1
      }
      let message = row.isCollect == 0 ? "取消收藏成功" : "收藏成功"
      modal.confirm('是否确认收藏"' + row.courseName + '"？').then(function () {
        return getCollect(param);
      }).then(() => {
        this.getCourseList()
        modal.msgSuccess(message);
      }).catch(() => { });
    },
    handleStartCourse(course) {
      // messageWarn(this, '功能正在开发中！')
      this.$router.push({ name: 'course-details', query: { courseId: course.id } })
    },
    scrollList() {
      if (this.isLastPage) {
        messageWarn(this, '暂无更多数据！')
        return
      }
      if (this.loading) {
        messageWarn(this, '正在拼命加载！')
        return
      }
      this.loading = true
      setTimeout(() => {
        this.query.pageNum++
        getCourseList(this.query).then(response => {
          const { total, rows } = response
          this.updateCourseList(rows)
          this.total = total
          this.isLastPage = total <= (this.query.pageNum * this.query.pageSize)
          console.log(this.query.pageNum)

          console.log(this.isLastPage)
          this.loading = false
        }).catch(() => {
          messageWarn(this, '加载数据失败！')
          this.loading = false
        })
      }, 500)
    },
    updateCourseList(list) {
      console.log(list)
      if (this.query.pageNum == 1) {
        this.courseList = list
        console.log(this.courseList)
      } else {
        console.log(this.courseList)
        console.log(list)
        const lists = [...this.courseList, ...list]
        this.courseList = lists
        console.log(lists)
      }

    },
    // 点击跳转学习页面
    getCourseware(row){
      getCourseState(row.id).then((res)=>{
        this.$router.push({ path: '/courseware', query: { id: row.id } })
      })
    }
  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.clever-category {
  display: flex;
  width: 100%;
  height: 80px;
  position: relative;
  align-items: center;
  justify-content: center;
  -webkit-box-pack: center;
  z-index: 2;

  h3 {
    text-align: center;
    font-size: 30px;
    text-transform: uppercase;
    letter-spacing: 0.75px;
    color: #3762f0;
    margin-bottom: 0;
  }
}

.clever-category::after {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  content: '';
  background-color: rgba(215, 224, 252, 0.9);
  z-index: -1;
}

.bg-img {
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
}

.search {
  @media(max-width: 1060px) {
    margin: 10px 0;
  }
}

.course-card-list {
  width: 100%;
  height: auto;
  overflow: auto;
  display: flex;
  flex-wrap: wrap;
  // justify-content: space-between;
  margin-right: -30px;
  margin-top: 20px;
  flex-direction: row;

  @media(max-width: 1060px) {
    width: 100%;
    margin: 0 auto;
  }


  .single-popular-course {
    width: calc(100% / 4 - 30px);
    margin-right: 30px;
    padding: 15px;
    border: 1px solid #ddd;
    position: relative;
    margin-bottom: 30px;
    border-radius: 6px;
    box-shadow: 0 3px 8px rgba(0, 0, 0, 0.15);

    @media(max-width: 1060px) {
      width: 100%;
      margin-right: 0;
      margin-bottom: 3rem;
    }

    .course_title {
      font-size: 20px;
      color: #3762f0;
      margin: 5px 0;
      line-height: 28px;
      font-weight: bold;
      max-height: 56px;
      display: -webkit-box;
      /* 将对象作为弹性伸缩盒子模型显示 */
      -webkit-box-orient: vertical;
      /* 设置或检索伸缩盒对象的子元素的排列方式 */
      -webkit-line-clamp: 2;
      /* 限制在一个块元素显示的文本的行数 */
      overflow: hidden;
      // text-overflow: ellipsis;
      // white-space: nowrap;
    }

    .course_info {
      display: flex;

      .course_info_left {
        flex: 1;
        overflow: hidden;
        font-size: 16px;
        line-height: 32px;

        .price {
          display: inline-block;
          vertical-align: middle;
          padding: 0 15px;
          color: rgb(245, 108, 108);
          background: rgb(254, 240, 240);
          border-color: rgb(251, 196, 196);
          border-radius: 40px;
          line-height: 24px;
        }
      }

      .course_info_right {
        width: 60px;
        font-size: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .active {
        color: yellow;
      }
    }



    .card-item-snapshoot {
      border: 1px solid rgba(0, 0, 0, .15);
      background-origin: border-box;
      background-size: cover;
      background-color: #f0f0f0;
      background-position: 49% 38%;
      height: 172px;
      display: block;
      border-radius: 6px 6px 0 0;
    }

    .card-item-detail {
      padding: 20px;

      .card-item-name {
        display: -webkit-box;
        overflow: hidden;
      }

      .card-item-course {
        --x-height-multiplier: 0.342;
        --baseline-multiplier: 0.22;
        font-weight: 300;
        font-style: normal;
        letter-spacing: 0;

        .card-item-course-detail {
          color: rgba(0, 0, 0, .54);
          fill: rgba(0, 0, 0, .54);
        }
      }
    }
  }

  >i {
    width: 30%;
    padding-right: 12px;
  }
}
</style>
